import { render, staticRenderFns } from "./weekdays-setting.vue?vue&type=template&id=6b8ada97"
import script from "./weekdays-setting.vue?vue&type=script&lang=js"
export * from "./weekdays-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports